import React from 'react'
import { compose } from 'recompose'
import inCartApis from 'apis/incartApis'
import withFetchResource from '../bases/withFetchResource'
import withLoading from 'hocs/bases/withLoading'

const withFetchMagentoCategories = () => {
  return compose(
    withFetchResource({
      resourceName: 'magentoCategories',
      getAction: () => inCartApis.getMagentoCategories,
      getSuccessData: ({ data }) => data.childrenData,
      getInitialResource: () => ([]),
    }),
    withLoading({
      getIsLoading: (props) => props.fetchMagentoCategoriesStatus.isRequest,
      getMessage: () => 'Loading...'
    })
  )
}

export default withFetchMagentoCategories



// WEBPACK FOOTER //
// ./src/hocs/extends/withFetchMagentoCategories.js